
export interface SeekSubmitInput {
    input: string;
}

export interface SeekSubmitOutput {
    seek_id: string;
}

export interface ISuggestList {
    PATENT_ID: string;
    PN: string;
}

export enum E_ErrorCode {
    SEEK_QUESTION_LIMIT = 90164076
}
